import React, { Suspense } from 'react';
import { withRouter } from "react-router-dom";
import ScrollAnimation from 'react-animate-on-scroll';
import SecondImage from '../../assets/images/bizdocs_devices.png';
import FirstImage from '../../assets/images/digitalArchiveLP.png';
import ListImage from '../../assets/images/list.png';
import BizIcon from '../../assets/images/bizIcon.png';
import { CardsBox } from '../../components/CardsBox/CardsBox';
import Header from '../../components/Header/HeaderLP';
import BookDemoButton from '../../components/shared/BookDemoButton/BookDemoButton';
import DesktopFooter from '../../components/shared/DesktopFooter/DesktopFooterLandingPage';
import Loader from '../../components/shared/Loader/Loader';
import MobileFooter from '../../components/shared/MobileFooter/MobileFooterLandingPage';
import TextCheck from '../../components/shared/TextCheck/BigTextCheck';
import Testimonials from '../../components/Testimonials/Testimonials2';
import GlobalStyles from '../../global.styles';
import { cards } from './cardsContent';
import { MarginOverlapBox, ContentOverlapBox, ImageOverlapBox, ImageOverlap, ContentBox, Image, Img, ImgBox, ImageBox, ImgMobileBox, MarginBox, OtherContentBox, StripCenter, StripLeft, StripRight, SubContentBox, TextContent, Title, SubTitle, TitleLabel } from './DigitalArchiveLP.style';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const DigitalArchiveConst = withRouter(({ history }) => {

    const [show, setShow] = React.useState(false);
    const [showForm, setShowForm] = React.useState(false);

    const handleClose = () => {
        setShowForm(false)
        setShow(false)
    };
    const handleShow = () => setShow(true);

    const toggleNext = () => setShowForm(true);

    const sendEmailForm = async () => {

        let isFormValid = document.getElementById("bookForm").reportValidity();

        if (!isFormValid)
            return;

        await fetch('/welcome/api/Emails/demo/LP', {
        //await fetch('/api/Emails/demo/LP', {
            method: "POST",
            body: JSON.stringify({
                name: document.getElementById("demoName").value,
                email: document.getElementById("demoEmail").value,
                phoneNumber: document.getElementById("demoTelemovel").value,
                company: document.getElementById("demoEmpresa").value,
                software: document.getElementById("demoSoftware").value
            }),
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
        }).then(res => res.json()).then(
            (result) => {
                //toggleNext();
                window.sourcePage = "LP";
                history.push("/thank-you");
            },
            (error) => {

            }
        )
    };

    return (
        <>
            <GlobalStyles />

            <Modal show={show} size="lg" onHide={handleClose}>
                <form id="bookForm">
                    <Modal.Header closeButton>

                        <Modal.Title className="w-100 text-center"><h1 style={{ color: "#6CB93D", fontSize: "26px" }}>Quero marcar uma demonstração</h1></Modal.Title>

                        {/*<Modal.Title className={(!showForm) ? "d-none" : "w-100 text-center"}><h1 style={{ color: "#6CB93D", fontSize: "26px" }}>Muito obrigado!</h1></Modal.Title>*/}
                    </Modal.Header>
                    <Modal.Body>
                        {/*<SubTitle className={showForm ? "d-none" : null} align="center" margin="0" mini="true">Por favor, preencha os seus dados para entrarmos em contacto:</SubTitle>*/}
                        <SubTitle align="center" margin="0" mini="true">Por favor, preencha os seus dados para entrarmos em contacto:</SubTitle>
                        {/*<MarginBox className={showForm ? "d-none" : null}>*/}
                        <MarginBox>
                            <OtherContentBox size="100%">
                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Nome</label>
                                    <input id="demoName" type="text" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Email</label>
                                    <input id="demoEmail" type="email" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Telemóvel</label>
                                    <input id="demoTelemovel" type="tel" className="form-control" required pattern="[0-9]{9}" />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Empresa</label>
                                    <input id="demoEmpresa" type="text" className="form-control" required />
                                </div>

                                <div className="form-group">
                                    <label style={{ color: "#1b2555" }}>Software de Contabilidade</label>

                                    <select id="demoSoftware" className="form-control" required defaultValue="">
                                        <option style={{ color: "#1b2555" }} value="" disabled>Selecione uma opção</option>
                                        <option style={{ color: "#1b2555" }} value="sage">Sage</option>
                                        <option style={{ color: "#1b2555" }} value="primavera">Primavera</option>
                                        <option style={{ color: "#1b2555" }} value="phc">PHC</option>
                                        <option style={{ color: "#1b2555" }} value="outro">Outro</option>
                                    </select>
                                </div>

                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id="demoCheck" required />
                                    <label className="form-check-label" style={{ color: "#1b2555" }}>
                                        Ao submeter este formulário declara que os dados preenchidos são verdadeiros e aceita que sejam guardados pela Latourrette Consulting | Bizdocs sob finalidade de poder ser contactado por um Parceiro Autorizado das marcas.
                                </label>
                                </div>

                            </OtherContentBox>
                        </MarginBox>
                        {/*
                        <MarginBox className={showForm ? null : "d-none"} >
                            <OtherContentBox size="100%" >
                                <SubTitle align="center" margin="0">
                                    Em breve iremos entrar em contacto para agendar a demonstração e ajudá-lo a poupar tempo, ser mais produtivo e eficaz!
                                </SubTitle>
                                <img style={{ width: "50px", height: "50px", alignSelf: "center", margin: "50px" }} src={BizIcon} alt=""/>
                                <SubTitle align="center" margin="0" mini="true">
                                    Entretanto, <a href="https://bizdocs.mobi/welcome/news">visite o nosso blog</a> ou as nossas redes sociais e fique a par de todas as novidade sobre Contabilidade!
                                </SubTitle>
                            </OtherContentBox>
                        </MarginBox>
                        */}
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                        {/*
                        <Button className={showForm ? "d-none" : null} style={{ backgroundColor: "#6CB93D", color: "#FFFFFF" }} variant="default" onClick={sendEmailForm}>
                            Enviar
                        </Button>
                        */}
                        <Button style={{ backgroundColor: "#6CB93D", color: "#FFFFFF" }} variant="default" onClick={sendEmailForm}>
                            Enviar
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Header bgColor="#1B2555" buttonFunc={handleShow}/>
            
                <MarginBox>
                <ContentBox showInMobile="true" size="50%">
                        <TextContent>
                            <h1 className="first">
                                <span className="first">Arquivo Digital</span>:
                                <br />
                                a sua ferramenta <span className="first">'tudo em um'</span>
                                <br />
                                que lhe oferece tempo e paz
                            </h1>
                            <ImgMobileBox>
                            <Image minHeight="60vh" imageSrc={FirstImage} />
                            </ImgMobileBox>  
                            <p>
                            O Bizdocs é uma solução inteligente de gestão documental. Evite desperdícios de tempo em tarefas repetitivas. Automatize processos para reduzir custos. 
                            <br />
                            Aumente a sua eficácia. 
                            <br />
                            Transforme-se no parceiro estratégico dos negócios dos seus clientes, oferecendo informação valiosa para que possam gerir as suas empresas.
                            </p>
                        </TextContent>
                        <TitleLabel align="left" margin="0px 0px 25px">Marque pela diferença.</TitleLabel>
                    <BookDemoButton
                        content="Quero marcar uma demonstração"
                        maxWidth="337px"
                        margin="0 10px 0 0" minheight="55px"
                        doStuff={handleShow} />
                </ContentBox>
                <ContentBox size="5%" />
                <ImgBox showInMobile="false" size="45%">
                    <Img imageSrc={FirstImage} />
                </ImgBox>
                </MarginBox>
                <StripRight />
            
            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginOverlapBox showAsStackInMobile="true">
                    <ContentOverlapBox showInMobile="true" size="50%">
                        <TextContent>
                            <h1>
                                Se isto lhe é familiar, <br />então precisa <br />do <span>Arquivo Digital Bizdocs</span>...
                            </h1>
                        </TextContent>
                    </ContentOverlapBox>
                    <ImageOverlapBox showInMobile="true" size="100%">
                        <ImageOverlap imageSrc={ListImage} />
                    </ImageOverlapBox>
                </MarginOverlapBox>
                <StripLeft />
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <ContentBox showInMobile="true" size="50%">
                        <TextContent>
                            <h1>
                                Onde quiser, quando quiser
                            </h1>
                            <p>
                                Trabalhe quando e onde quiser: no escritório, no café, nos transportes, no hotel, em casa… No computador, no tablet ou no smartphone.
                            </p>
                            <p className="green">
                                O Bizdocs é simples de implementar e fácil de usar.
                            </p>
                            <ImgMobileBox>
                                <Image imageSrc={SecondImage} />
                            </ImgMobileBox> 
                        </TextContent>
                    </ContentBox>
                    <ImageBox size="50%">
                        <Image minHeight="42vh" imageSrc={SecondImage} />
                    </ImageBox>
                </MarginBox>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <Testimonials />
                <MarginBox>
                    <BookDemoButton
                        content="Quero marcar uma demonstração"
                        maxWidth="500px"
                        margin="0 0 50px 0" minheight="55px"
                        doStuff={handleShow}/>
                </MarginBox>
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <CardsBox items={cards} />
                <StripCenter />
            </ScrollAnimation>
            <ScrollAnimation animateOnce animateIn="fadeInUp" duration={1} delay={1}>
                <MarginBox>
                    <OtherContentBox size="100%">
                        <TextContent>
                            <Title margin="">
                                Arquivo Digital Bizdocs é <span>simples</span> e <span>completo</span>, com <span>tudo num único lugar</span>
                            </Title>   
                        </TextContent>
                    </OtherContentBox>
                </MarginBox>
                <MarginBox>
                    <SubContentBox size="100%">
                        <TitleLabel align="center" margin="0px 0px 25px">Tenha total controlo sobre todos os documentos.</TitleLabel>
                        <TitleLabel align="center" margin="0px 0px 25px">Ganhe eficiência, rapidez e seja o profissional com quem todas as empresas querem trabalhar.</TitleLabel>
                    </SubContentBox>
                </MarginBox>
                <MarginBox>
                    <OtherContentBox size="100%">
                        <TextCheck content="Classifique, processe e faça a gestão de todos os documentos contabilísticos sem depender de papéis que andam de mão em mão;"/>
                        <TextCheck content="Automatize tarefas e procedimentos comuns;"/>
                        <TextCheck content="Aceda a um portal ONLINE onde estão todos os seus clientes, cada um com o seu arquivo próprio, para uma gestão eficaz;"/>
                        <TextCheck content="Elimine a necessidade de receção de documentos por email e a incerteza de os ter ou não recebido;"/>
                        <TextCheck content="Tenha todos os documentos ao alcance de dois ou três cliques, esteja onde estiver, para que não perca tempo;"/>
                        <TextCheck content="Total segurança, graças a uma encriptação blindada de última geração e níveis de acesso parametrizáveis, oferecendo-lhe um sono descansado;"/>
                        <TextCheck content="Sincronização total, para que tenha sempre a informação mais recente;"/>
                        <TextCheck content="Em conformidade com a legislação de desmaterialização de documentos e processamento de faturas (DL28/19);"/>
                        <TextCheck content="Garantia de cumprimento da Lei e das exigências da administração fiscal, com atualizações permanentes, para dose extra de confiança;"/>
                        <TextCheck content="Suporte especializado e que conhece os seus problemas do dia-a-dia."/>
                    </OtherContentBox>
                </MarginBox>  
                <MarginBox>
                    <BookDemoButton
                        content="Quero marcar uma demonstração"
                        maxWidth="500px"
                        margin="10vh auto" minheight="55px"
                        doStuff={handleShow}/>
                </MarginBox>
            </ScrollAnimation>

            <DesktopFooter />
            <MobileFooter />
        </>
    );
});

export default function DigitalArchiveLP() {
    return (
        <Suspense fallback={<Loader />}>
            <DigitalArchiveConst />
        </Suspense>
    );
}